<div class="flex justify-content-between flex-column h-full">
  <section>
    <ng-container>
      <div class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
        [style]="{ 'border-color': 'var(--primary-gray)' }">
        <h2 class="text-xl font-semibold" data-clarity-unmask="true">Dodaj OSK</h2>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
      </div>
    </ng-container>
    <p>Uzupełnij dane OSK</p>
    <form [formGroup]="mainOSKDataForm">
      <div class="flex flex-wrap sm:flex-nowrap py-2" [ngClass]="userOption ? 'border-bottom-1 border-bluegray-300' : ''">
        <label for="ownerEmail"
          class="flex-none flex align-items-center w-11rem text-gray-500 font-normal text-sm">Adres
          e-mail<i class="pi pi-info-circle ml-2"
            pTooltip="Podaj adres e-mail, który będzie używany do logowania przez OSK."
            tooltipPosition="bottom"></i></label>
        <div class="w-full flex-grow-1 flex align-items-center">
          <div class="flex flex-column w-full">
            <p-autoComplete [autofocus]="true" class="w-full" styleClass="w-full" id="ownerEmail"
              formControlName="ownerEmail" [suggestions]="filteredUsers" optionLabel="email" field="email"
              (onBlur)="checkIfEmailExists()" (onSelect)="onEmailSelect($event)" placeholder="Wyszukaj po adresie email"
              [showEmptyMessage]="false" aria-describedby="email-help"></p-autoComplete>
            <small *ngIf="emailExists" class="info-message" id="email-help">
              Dla podanego adresu email istnieje już konto na platformie.
              Przypisz go do OSK lub podaj inny adres email.
            </small>
            <small *ngIf="showError" class="error-message">
              {{
              mainOSKDataFc["ownerEmail"].value === ""
              ? "Wprowadź adres email"
              : "Niepoprawny adres email"
              }}
            </small>
            <small *ngIf="showNotFoundMessage" class="warning-message">
              Nie znaleziono konta na platformie. Możesz stworzyć nowe konto dla
              podanego adresu email.
            </small>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showOSKForm">
        <div class="flex flex-wrap justify-content-between">
          <ng-container *ngFor="let field of mainDataFormFields">
            <div [ngSwitch]="field.type"
              class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300 py-2"
              [ngClass]="field.fieldWidth ? '' : 'lg:w-27rem'">
              <label [for]="field.name"
                class="flex-none flex align-items-center w-11rem text-gray-500 font-normal text-sm">
                <span class="text-sm">{{ field.label }}<i *ngIf="field.fieldTooltip" class="pi pi-info-circle ml-2"
                    [pTooltip]="field.fieldTooltip" tooltipPosition="bottom"></i></span>
              </label>
              <div class="w-full flex align-items-center gap-2">
                <input *ngSwitchDefault [id]="field.name" type="text" pInputText [formControlName]="field.name" />
                <p-inputNumber [inputId]="field.name" *ngSwitchCase="'input-number'" class="w-full" styleClass="w-full"
                  [inputId]="field.name" [formControlName]="field.name" locale="pl-PL"
                  [minFractionDigits]="field.minFractionDigits ?? 2" [maxFractionDigits]="field.maxFractionDigits ?? 2"
                  currency="PLN" [mode]="field.currencyField ? 'currency' : 'decimal'" />
                <p-inputMask [inputId]="field.name" *ngSwitchCase="'input-mask'" class="w-full" styleClass="w-full"
                  [mask]="field.mask ? field.mask : '9999999'" [formControlName]="field.name"
                  [placeholder]="field.mask ? field.mask : '9999999'" />
                <p-button *ngIf="field.name === 'oskNip'" label="Wczytaj z GUS" icon="pi pi-download"
                  styleClass="white-space-nowrap" [loading]="gusLoading" [disabled]="loading"
                  (onClick)="loadFromGus()" data-clarity-unmask="true" />
              </div>
            </div>
            <small
              *ngIf="field.name === 'oskShortCode' && mainOSKDataFc['oskShortCode'].hasError('shortCodeTaken')"
              class="error-message w-full">
              Ta nazwa skrócona jest już zajęta — wybierz inną.
            </small>
          </ng-container>
        </div>
      </ng-container>
    </form>
    <div class="py-3">
      <p-checkbox *ngIf="showOSKForm" [(ngModel)]="invoiceRequested" (ngModelChange)="updateInvoiceData()"
        [binary]="true" label="Dane do faktury" inputId="binary" />
    </div>
    <ng-container>
      <form [formGroup]="invoiceOSKForm">
        <div class="flex flex-wrap justify-content-between mb-3" *ngIf="invoiceRequested">
          <ng-container *ngFor="let field of invoiceFormFields">
            <div [ngSwitch]="field.type"
              class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300 py-2"
              [ngClass]="field.fieldWidth ? '' : 'lg:w-27rem'">
              <label [for]="field.name"
                class="flex-none flex align-items-center w-11rem text-gray-500 font-normal text-sm">
                <span class="text-sm">{{ field.label }}<i *ngIf="field.fieldTooltip" class="pi pi-info-circle ml-2"
                    [pTooltip]="field.fieldTooltip" tooltipPosition="bottom"></i></span>
              </label>
              <div class="w-full flex align-items-center">
                <input *ngSwitchDefault [id]="field.name" type="text" pInputText [formControlName]="field.name" />
                <p-inputNumber [inputId]="field.name" *ngSwitchCase="'input-number'" class="w-full" styleClass="w-full"
                  [inputId]="field.name" [formControlName]="field.name" locale="pl-PL"
                  [minFractionDigits]="field.minFractionDigits ?? 2" [maxFractionDigits]="field.maxFractionDigits ?? 2"
                  currency="PLN" [mode]="field.currencyField ? 'currency' : 'decimal'" />
                <p-inputMask [inputId]="field.name" *ngSwitchCase="'input-mask'" class="w-full" styleClass="w-full"
                  [mask]="field.mask ? field.mask : '9999999'" [formControlName]="field.name"
                  [placeholder]="field.mask ? field.mask : '9999999'" />
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </ng-container>

  </section>
  <section class="flex flex-wrap sm:flex-nowrap gap-3 justify-content-between">
    <div>
      <p-checkbox *ngIf="showOSKForm" [(ngModel)]="sendInvitationEmail" [binary]="true"
        label="Wyślij zaproszenie do użytkownika" inputId="binary" />
    </div>
    <div class="flex gap-3 ml-auto">
      <p-button label="Anuluj" (onClick)="closeDialog()" [outlined]="true" [disabled]="loading" data-clarity-unmask="true">
      </p-button>
      <p-button label="Zapisz" icon="pi pi-save" (onClick)="addUserToOSK()" [loading]="loading" data-clarity-unmask="true">
      </p-button>
    </div>
  </section>
</div>